module.exports = __webpack_public_path__ + "img/irose-test4-step2a.619a7916.png";